define('views/parts/menu/menu',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // views
    'views/parts/menu/menu-item'
], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // views
    VMenuItem
) {

    /**
     * Generic menu view.
     *
     * 	   // build collection for item (best in initialize function of your view)
     *     this.actionCollection = new Backbone.Collection([
     *         { title: 'New message', icon: false, callback: this.onNewMessage },
     *         { title: 'Search', icon: 'sl-icon-magnifier', callback: this.onSearchTrigger },
     *         { title: 'Delete all selected message', icon: 'sl-icon-trash', callback: this.onDeleteMessage },
     *     ]);
     *
     *     // you can listen for the click callback or use the 'onClick' option.
     *     this.listenTo(this.actionCollection, "item:click", this.onActionClicked);
     *
     *     // Create a new menu view instance
     *     this.view.menu = new VMenu({
     *         templateItem: '{{^empty}}<span class="{{icon}}"></span><p>{{title}}</p>{{/empty}}',
     *         radio: false,
     *         collection: this.actionCollection,
     *         context: this,
     *         onClick: this.onMenuClick
     *     });
     *
     *
     * @param  {Boolean} radio (optional, false) if it should apply 'active' class on item click. Default to false.
     * @param  {String|Array} namespace (optional) i18n namespace to translace with the content as the key.
     * @param  {string} templateItem (optional, menu-actions) items HTML template.
     * @param  {Object} context (optional) the "this" value inside the callback if provided in the item collection.
     * @param  {Backbone.Collection} collection, each item model to use inside the item's template.
     * @param  {Object} tooltip the options to pass to the bootstrap tooltips.
     */
    var VMenu = Backbone.View.extend({
        defaults: {
            tooltipSelector: '[data-toggle="tooltip"]',
        },

        initialize: function(opt) {
            opt = this.options = _.extend({}, _.omit(opt, 'template'));

            // default tooltip options
            var tooltip = opt.tooltip;
            if (tooltip) {
                tooltip = opt.tooltip = _.extend({
                    delay: { "show": 250, "hide": 250 },
                    trigger: 'hover',
                }, tooltip);
                if (!tooltip.viewport) {
                    tooltip.viewport = tooltip.container;
                }
            }

            if (!this.collection) this.collection = new Backbone.Collection();

            this.listenTo(this.collection, {
                "add": this.onItemAdd,
                "reset:active": this.onChangeActive,
                "item:click": this.onItemClick,
            });
        },

        render: function() {
            this.$el.empty();

            this.removeChildViews({ defer: true });

            this.addAll();
            return this;
        },

        addAll: function() {
            var container = document.createDocumentFragment();

            this.collection.each(function(model) {
                container.appendChild(this.addOne(model, false).el);
            }, this);

            this.$el.append(container);
        },
        addOne: function(tabModel, render) {
            var ItemView = tabModel.get('view') ? tabModel.get('view') : VMenuItem,
                view = new ItemView(_.extend({
                    model: tabModel
                }, this.options, {
                    menu: this
                }));
            this.childViews.push(view);
            view.render();

            if (render !== false) {
                this.$el.append(view.el);
            }

            return view;
        },

        resetTooltips: function(options) {
            this.$(this.defaults.tooltipSelector)
                .tooltip('destroy')
                .tooltip(options);
        },

        getCollection: function() {
            return this.collection;
        },

        setItems: function(items) {
            return this.collection.reset(items);
        },

        removeItem: function(itemId) {
            this.collection.remove(itemId);
        },

        addItem: function(item, options) {
            this.collection.add(item, options);
        },

        getItemCount: function() {
            return this.collection.length;
        },

        findItem: function(itemId) {
            return this.collection.get(itemId);
        },

        toggleActive: function(item, value) {
            var model = this.deactivate(),
                hasValue = !_.isUndefined(value);
            if ((!item.is(model) || hasValue) && item.get('toggle') !== false) {
                item.set('active', hasValue ? value : true);
            }
        },

        deactivate: function() {
            var models = this.collection.where({ active: true });
            if (models.length > 0) {
                _.each(models, function(item) { item.set('active', false); });
                return models.length === 1 ? models[0] : null;
            }
        },

        toggleHiddenButton: function(selector, val) {
            this.$el.find(selector).toggle(val);
        },

        ////////////
        // events //
        ////////////
        onChangeActive: function() {
            if (this.options.radio) {
                this.deactivate();
            }
        },
        onItemClick: function(e, model) {
            if (!model.has('route')) e.preventDefault();
            _.callback(model.get('context') || this.options.context || this, this.options.onClick, [e, model, this]);
            this.trigger("item:click", e, model, this);
        },

        onItemAdd: function(model, collection) {
            this.addOne(model);
        },

    });

    return VMenu;
});

